import script from "./LogOutUser.vue?vue&type=script&setup=true&lang=js"
export * from "./LogOutUser.vue?vue&type=script&setup=true&lang=js"

import "./LogOutUser.vue?vue&type=style&index=0&id=54be75fc&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-54be75fc"]])

export default __exports__